<template>
  <el-row>
    <el-col :span="24">
      <el-card class="data" v-loading="loading">
        <div class="data-title flex-space-between" slot="header">
          <p>Category</p>
          <div>
            <el-tooltip content="Insert" placement="top">
              <el-button
                type="success"
                circle
                icon="el-icon-check"
                @click.prevent="insert()"
              ></el-button>
            </el-tooltip>
          </div>
        </div>
        <Table />
        <Dialog />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Table from './TableCategory'
import Dialog from './DialogCategory'
import { mapState, mapMutations } from 'vuex'

export default {
  components: {
    Table,
    Dialog
  },

  computed: {
    ...mapState('faq', ['loading'])
  },

  methods: {
    ...mapMutations('faq', ['setDialogCategory', 'setSelectedCategory']),
    initialCategory() {
      return {
        id: null,
        name: '',
        position: null
      }
    },
    insert() {
      this.setDialogCategory(true)
      this.setSelectedCategory(this.initialCategory())
    }
  }
}
</script>
